module.exports = __webpack_public_path__ + "media/images/PSW-97f46a7110a239726516ffc67e3f204e.png";